exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".objectView[data-v-db219134]{height:200px;position:relative;display:flex;flex-direction:column;align-items:center;background-color:#333;margin:10px;border-radius:5px;border:1px solid transparent}.objectView h3[data-v-db219134]{text-align:center;margin-bottom:8px}a.nostyle[data-v-db219134]:link,a.nostyle[data-v-db219134]:visited{text-decoration:inherit;color:inherit}.objectView .badges[data-v-db219134]{position:absolute;right:16px;bottom:12px;display:flex}.objectView .badge[data-v-db219134]{margin-left:16px;font-size:15px}.objectView .badge img[data-v-db219134]{vertical-align:-2px}.objectView .badgeValue[data-v-db219134]{margin-left:3px}@media only screen and (min-width:768px){.objectView[data-v-db219134]:hover{border:1px solid #eee;background-color:#222}}@media only screen and (max-width:768px){.objectView h3[data-v-db219134]{font-size:16px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-db219134","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ObjectView.vue
// module id = 88
// module chunks = 0